import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';

export interface BehaviorGoalExamples {
  behavioral_goals: { goal: string; description: string }[];
  note: string;
}

@Component({
  selector: 'app-define-behavior-wizard-info-modals',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NzButtonModule, NzModalModule, SvgIconComponent],
  templateUrl: './define-behavior-wizard-info-modals.component.html',
})
export class DefineBehaviorWizardInfoModalsComponent {
  @Input() isWarningModalVisible = false;
  @Input() isFunctionalEquivalentModalVisible = false;
  @Input() isSettingEventModalVisible = false;
  @Input() isGoalExampleModalVisible = false;
  @Input() isPdfModalVisible = false;
  @Input() behaviorGoalExamples!: BehaviorGoalExamples;
  @Input() trackByGoal!: (index: number, item: { goal: string }) => string;

  @Output() warningCancel = new EventEmitter<void>();
  @Output() functionalEquivalentVisibleChange = new EventEmitter<boolean>();
  @Output() settingEventVisibleChange = new EventEmitter<boolean>();
  @Output() goalExampleVisibleChange = new EventEmitter<boolean>();
  @Output() pdfVisibleChange = new EventEmitter<boolean>();
}
